<template>
  <el-select
    v-model="value"
    :class="`${bem.b()} ${prepareClassNames()}`"
    v-bind="customAttrs"
    :style="{
      ...prepareStyles(),
    }"
  >
    <el-option
      v-for="item in customOptions"
      :key="item[valueKey]"
      :class="bem.e('option')"
      :label="
        item.formatLabel
          ? item.formatLabel(item)
          : formatLabel
            ? formatLabel(item)
            : item[labelKey]
      "
      :value="item[valueKey]"
      :disabled="disabledOption(item)"
    >
      <slot name="option" :item="item">
        <template v-if="codeInLabel || codeInLabel === ''">
          <span style="float: left">{{ item[labelKey] }}</span>
          <span
            style="
              float: right;
              color: var(--el-text-color-secondary);
              font-size: 13px;
            "
          >
            {{
              item[
                typeof codeInLabel === 'string' && codeInLabel
                  ? codeInLabel
                  : valueKey
              ]
            }}
          </span>
        </template>
      </slot>
    </el-option>
    <template v-for="name in slots" #[name]="scope">
      <slot :name="name" v-bind="scope" />
    </template>
  </el-select>
</template>
<script setup lang="ts">
import { computed, useSlots, watch } from 'vue'
import {
  selectProps,
  selectEmits,
  expandSelectPropsKeys,
  selectEmitsKeys,
} from './select'
import type { SelectProps, SelectEmits } from './select'
import {
  prepareProps,
  prepareEvents,
  prepareClassNames,
  prepareStyles,
} from '@el-plus/utils/props'
import { useSelect } from './use-select'
import { createNameSpace } from '@el-plus/utils/bem'
defineOptions({
  name: 'EpSelect',
  inheritAttrs: false,
})
const bem = createNameSpace('select')
const props = defineProps(selectProps)
const emit = defineEmits(selectEmits)
const slots = computed(() => {
  return Object.keys(useSlots())
})

const { customOptions, loadOptions, expandAttrs } = useSelect(props, emit)
const value = defineModel<SelectProps['modelValue']>()
const customAttrs = computed(() => {
  return {
    ...prepareProps(props, ['modelValue', 'desc', ...expandSelectPropsKeys]),
    ...prepareEvents<SelectEmits>(emit, selectEmitsKeys),
    ...expandAttrs.value,
  }
})
// 回显由 echoOption computed 自动处理,这里只负责加载选项
loadOptions()
watch(
  () => props.options,
  () => {
    loadOptions()
  },
  {
    deep: true,
  },
)
</script>
